import { IConfig } from "./Render";

export const SvgImage = ({ className, id, style, extraProps, height, width, src }: IConfig) => {
    return (
        <image id={id} className={className} style={style}
            height={height} width={width}
            href={src}
            x={extraProps.x} y={extraProps.y} />
    );
}